import React, { useState, useEffect, useRef } from "react";

import "./EcommerceCheckout.scss"
import CheckoutItem from "./CheckoutItem/CheckoutItem";
import Header from "../../components/Header/Header";
import InputComponent from "../../components/InputComponent/InputComponent";
import Checkbox from "../../components/Checkbox/Checkbox";
import PaymentComponent from "../../components/PaymentComponent/PaymentComponent";
import RadioButton from "../../components/RadioButton/RadioButton";
import Button from "../../components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import EcommercePayment from "./EcommercePayment/EcommercePayment";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import axios from 'axios';
import { renderEmail } from 'postonents';
import moment from 'moment';
import config from 'react-global-configuration';
import jwt from 'jsonwebtoken';
import OrderEmail from "../../email/OrderEmail";
import { setCart } from "../../../../../../../redux/companyDataSlice";
import PhoneInpuComponent from "../../components/InputComponent/PhoneInpuComponent";
import { isValidPhoneNumber } from 'react-phone-number-input';
import { sendPaymentDetails } from "../../../RestaurantWidget/utilities/api/paymentService";
import Modal from "../../components/Modal/Modal";

const EcommerceCheckout = () => {
    const history = useHistory()
    const disptach = useDispatch()
    const companyDetails = useSelector((state) => state.companyData.company)

    const cart = useSelector((state) => state.companyData.cart)
    const adyenRef = useRef(null);
    const search = history.location.search;
    const params = new URLSearchParams(search);
    const redirectResult = params.get('redirectResult');
    let parsedUserDetails = localStorage.getItem('fullUserDetails') && JSON.parse(localStorage.getItem('fullUserDetails'))
    const address = parsedUserDetails ? parsedUserDetails?.Addresses?.find((address) => address.AddressType === "Billing") || null : null
    const addressDelivery = parsedUserDetails ? parsedUserDetails?.Addresses?.find((address) => address.AddressType === "Delivery") || null : null

    const [isSame, setIsSame] = useState(false);
    const [subOrderTypes, setSubOrderTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [showPaymentErrorModal, setShowPaymentErrorModal] = useState(false)
    const [showPaymentError, setShowPaymentError] = useState(false)

    const [contactDetails, setContactDetails] = useState({
        firstName: parsedUserDetails ? parsedUserDetails?.FirstName : "",
        lastName: parsedUserDetails ? parsedUserDetails?.LastName : "",
        email: parsedUserDetails ? parsedUserDetails?.Email : "",
        phoneNumber:
            parsedUserDetails
                ? address?.Phone || addressDelivery?.Phone || ""
                : ""
    })
    const [deliveryDetails, setDeliveryDetails] = useState({
        address1: addressDelivery?.AddressLine1 || "",
        address2: addressDelivery?.AddressLine2 || "",
        city: addressDelivery?.City || "",
        state: addressDelivery?.StateProvinceRegion || "",
        country: addressDelivery?.Country || 'United Kingdom',
        postal: addressDelivery?.PostZipCode || ""
    })
    const [billingDetails, setBillingDetails] = useState({
        address1: address ? address?.AddressLine1 : "",
        address2: address ? address?.AddressLine2 : "",
        city: address ? address?.City : "",
        state: address ? address?.StateProvinceRegion : "",
        country: address ? address?.Country : 'United Kingdom',
        postal: address ? address?.PostZipCode : ""
    })
    const [selectedValue, setSelectedValue] = useState("CASH");
    const [selectedTypeValue, setSelectedTypeValue] = useState(subOrderTypes[0]?.SubOrderTypeName || "");
    const [avalaiblePaymentTypes, setAvalablePaymentTypes] = useState(subOrderTypes[0]?.AvailablePaymentTypes || []);
    const [errors, setErrors] = useState({
        email: "",
        firstName: "",
        lastName: "",
        address1: "",
        city: "",
        state: "",
        postal: "",
        country: "",
        phoneNumber: "",
        deliveryAddress1: "",
        deliveryCity: "",
        deliveryState: "",
        deliveryPostal: "",
        deliveryCountry: "",
    })

    const handleChange = (value) => {
        setSelectedValue(value.toUpperCase());
        sessionStorage.setItem('paymentType', value);

    };
    const handleTypeChange = (value) => {
        let type = subOrderTypes.find((order) => order.SubOrderTypeName === value)
        setAvalablePaymentTypes(type)
        setSelectedValue(type[0]?.toUpperCase())
        setSelectedTypeValue(value);
        sessionStorage.setItem('deliverymethod', value)
    };
    useEffect(() => {
        window.scrollTo(0, 0);
        localStorage.setItem("ecurrencyratio", 1)
    }, []);
    useEffect(() => {
        if (redirectResult) {
            sendPaymentDetailsRedirect()
            setSelectedValue("CARD")
        }
    }, [])
    useEffect(() => {
        let settings = localStorage.getItem("ECOM_SETTINGS") && JSON.parse(localStorage.getItem("ECOM_SETTINGS")) || [];
        let orgID = companyDetails.OrganisationID
        sessionStorage.setItem('OriginatedOrganizationID', orgID);
        const types = settings.find((setting) => (setting.OrgID === orgID)) ? settings.find((setting) => (setting.OrgID === orgID))?.SubOrderTypes : []
        const orderTypes = types.filter((type) => type.IsActive)
        setSubOrderTypes(orderTypes)
        setSelectedTypeValue(orderTypes[0]?.SubOrderTypeName);
        sessionStorage.setItem('deliverymethod', orderTypes[0]?.SubOrderTypeName)
        setAvalablePaymentTypes(orderTypes[0]?.AvailablePaymentTypes)
        sessionStorage.setItem('paymentType', orderTypes[0]?.AvailablePaymentTypes[0]);
        setSelectedValue(orderTypes[0]?.AvailablePaymentTypes[0]?.toUpperCase())

    }, [])
    const onContactDetailsChange = (e, field) => {
        setContactDetails({ ...contactDetails, [field]: e.target.value })
        setErrors({
            ...errors,
            [field]: "",
        });
    }
    const onDeliveryDetailsChange = (e, field, errorField) => {
        setDeliveryDetails({ ...deliveryDetails, [field]: e.target.value })
        setErrors({
            ...errors,
            [errorField]: "",
        });
    }
    const onBillingDetailsChange = (e, field) => {
        setBillingDetails({ ...billingDetails, [field]: e.target.value })
        setErrors({
            ...errors,
            [field]: "",
        });
    }
    const handleCheckboxChange = () => {
        setIsSame(!isSame);
        if (!isSame) {
            setBillingDetails(deliveryDetails)
        } else {
            setBillingDetails({
                address1: address ? address?.AddressLine1 : "",
                address2: address ? address?.AddressLine2 : "",
                city: address ? address?.City : "",
                state: address ? address?.StateProvinceRegion : "",
                country: 'United Kingdom',
                postal: address ? address?.PostZipCode : ""
            })
        }
    };
    const handleLogout = () => {
        sessionStorage.clear()
        localStorage.clear()
        history.push("/")
    };
    const getTotalPrice = () => {
        const total = cart.reduce((sum, item) => {
            const qty = item.ProductQty || 0;
            const price = item.ProductPrice || 0;
            return sum + qty * price;
        }, 0);
        return total.toFixed(2);
    };
    const getCardTotalPrice = () => {
        const total = cart.reduce((sum, item) => {
            const qty = item.ProductQty || 0;
            const price = item.ProductPrice || 0;
            return sum + qty * price;
        }, 0);
        return Math.round(total * 100);
    };

    const getCustomerDetails = () => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
        const customerFormData = {
            ID: userId,
            Name: {
                DisplayName: contactDetails.firstName,
                FirstName: contactDetails.firstName,
                LastName: contactDetails.lastName
            },
            Email: contactDetails.email.trim(),
            Contact: {
                Number: contactDetails.phoneNumber,
                PinCode: "+44",
                CountryISO2: "GB",
            },
            BillingAddress: {
                Id: "",
                AddressType: "Billing",
                AddressLine1: billingDetails.address1,
                AddressLine2: billingDetails.address2,
                StateProvinceRegion: billingDetails.state,
                PostZipCode: billingDetails.postal,
                Country: billingDetails.country,
                City: billingDetails.city,
                CountryCode: "",
                AddressLabel: "",
                Longitude: 0,
                Latitude: 0,
                Additional: {
                    Instruction: "",
                    InteractionType: "",
                },
            },
            DeliveryAddress: {
                Id: "",
                AddressType: "Delivery",
                AddressLine1: deliveryDetails.address1,
                AddressLine2: deliveryDetails.address2,
                StateProvinceRegion: deliveryDetails.state,
                PostZipCode: deliveryDetails.postal,
                Country: deliveryDetails.country,
                City: deliveryDetails.city,
                CountryCode: "",
                AddressLabel: "",
                Longitude: 0,
                Latitude: 0,
                Additional: {
                    Instruction: "",
                    InteractionType: "",
                },
            },
        };
        return customerFormData
    }
    const validateForm = () => {
        let valid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const newErrors = {
            email: "",
            firstName: "",
            lastName: "",
            address1: "",
            city: "",
            state: "",
            postal: "",
            country: "",
            phoneNumber: "",
            deliveryAddress1: "",
            deliveryCity: "",
            deliveryState: "",
            deliveryPostal: "",
            deliveryCountry: "",
        };
        if (contactDetails.email === "") {
            newErrors.email = "*required";
            valid = false;
        }
        else if (!emailRegex.test(contactDetails.email)) {
            newErrors.email = "Invalid email format";
            valid = false;
        }
        if (contactDetails.firstName.trim() === "") {
            newErrors.firstName = "*required";
            valid = false;
        }
        if (contactDetails.lastName.trim() === "") {
            newErrors.lastName = "*required";
            valid = false;
        }
        if (contactDetails.phoneNumber.trim() === "") {
            newErrors.phoneNumber = "*required";
            valid = false;
        }
        if (!isValidPhoneNumber(contactDetails.phoneNumber)) {
            newErrors.phoneNumber = "Invalid phone number";
            valid = false;
        }
        if (billingDetails.address1.trim() === "") {
            newErrors.address1 = "*required";
            valid = false;
        }
        if (billingDetails.city.trim() === "") {
            newErrors.city = "*required";
            valid = false;
        }
        if (billingDetails.state.trim() === "") {
            newErrors.state = "*required";
            valid = false;
        }
        if (billingDetails.country.trim() === "") {
            newErrors.country = "*required";
            valid = false;
        }
        if (billingDetails.postal.trim() === "") {
            newErrors.postal = "*required";
            valid = false;
        }
        if (deliveryDetails.address1.trim() === "") {
            newErrors.deliveryAddress1 = "*required";
            valid = false;
        }
        if (deliveryDetails.city.trim() === "") {
            newErrors.deliveryCity = "*required";
            valid = false;
        }
        if (deliveryDetails.state.trim() === "") {
            newErrors.deliveryState = "*required";
            valid = false;
        }
        if (deliveryDetails.country.trim() === "") {
            newErrors.deliveryCountry = "*required";
            valid = false;
        }
        if (deliveryDetails.postal.trim() === "") {
            newErrors.deliveryPostal = "*required";
            valid = false;
        }
        if (valid) {
            sessionStorage.setItem("userCheckoutDetails", JSON.stringify(getCustomerDetails()))
        }
        setErrors(newErrors);
        return valid;
    }

    const handlePayClick = () => {
        sessionStorage.setItem('ordernumber', new Date().valueOf());
        setIsLoading(true)
        if (adyenRef.current) {
            adyenRef.current.submit();
        }
    };
    const handleCheckout = () => {
        setIsLoading(true)
        if (!sessionStorage.getItem('ordernumber') || sessionStorage.getItem('ordernumber') === "") {
            sessionStorage.setItem('ordernumber', new Date().valueOf());
        }
        const curentDateTime = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");


        const PIsales =
            cart.length ? (
                cart.map((item, index) => (
                    {
                        ProductID: item.ProductID,
                        ProductCategoryID: item.productdetails.ProductCategoryID,
                        SalesQuantity: parseFloat(cart[cart.findIndex(pid => pid.ProductID === item.ProductID)].ProductQty),
                        SalesPrice: parseFloat(parseFloat(item.productdetails.SellingPricesArray.SellingPrice * 1).toFixed(2)),
                        LineDiscount: 0,
                        LineVat: JSON.parse(localStorage.getItem("ECOM_SETTINGS"))[0].IsVatIncludedInSellingPrices ? parseFloat((((item.productdetails.SellingPricesArray.SellingPrice * (cart[cart.findIndex(pid => pid.ProductID === item.ProductID)].ProductQty)) * (1)) * (cart[cart.findIndex(pid => pid.ProductID === item.ProductID)].VatRate / (1 + cart[cart.findIndex(pid => pid.ProductID === item.ProductID)].VatRate))).toFixed(2)) : parseFloat(((item.productdetails.SellingPricesArray.SellingPrice * (cart[cart.findIndex(pid => pid.ProductID === item.ProductID)].ProductQty)) * (1)) * (cart[cart.findIndex(pid => pid.ProductID === item.ProductID)].VatRate).toFixed(2)),
                        LineAmount: parseFloat(((item.productdetails.SellingPricesArray.SellingPrice * cart[cart.findIndex(pid => pid.ProductID === item.ProductID)].ProductQty) * 1).toFixed(2)),
                        OriginalAmount: parseFloat((cart[cart.findIndex(pid => pid.ProductID === item.ProductID)].ProductQty * item.productdetails.SellingPricesArray.SellingPrice * 1).toFixed(2)),
                        PromotionAmount: 0,
                        SalesUnitTypeID: item.productdetails.SellingPricesArray.SalesUnitTypeID,
                        OrgID: sessionStorage.getItem('OriginatedOrganizationID'),
                    }

                )
                )
            ) : (
                {}
            )

        const PIoffers =
            cart.map((item, index) => (

                item.OfferAmount != 0 ? (
                    {
                        ProductID: 0,
                        ProductCategoryID: 0,
                        SalesQuantity: 0,
                        SalesPrice: 0,
                        LineDiscount: 0,
                        LineVat: 0,
                        LineAmount: 0,
                        OriginalAmount: 0,
                        SalesUnitTypeID: 0,
                        PromotionAmount: parseFloat(-Math.abs(item.OfferAmount).toFixed(2)),
                        PromotionName: item.offerdetails[0].Offer.PromotionName,
                        PromotionID: item.offerdetails[0].Offer.OfferID,
                        OrgID: sessionStorage.getItem('OriginatedOrganizationID'),

                    }
                ) : ''
            )
            )

        const formSales = {
            ProformaSales: {
                CloudCustomerID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                OrderType: "OnLine",
                DeliveryInstruction: '',
                SubTotal: parseFloat(getTotalPrice()),
                BulkDiscount: 0,
                VatAmount: 0,
                TotalInvoiceValue: parseFloat(getTotalPrice()),
                OfferDiscount: 0,
                Description: '',
                OrgID: sessionStorage.getItem('OriginatedOrganizationID'),
                AdditionalCharges: '',
                SubOrderType: sessionStorage.getItem('deliverymethod'),
                DeliveryCharge: 0,
                CurrencyID: parseInt(4),
                CartReference: sessionStorage.getItem('ordernumber'),
                PaymentToken: '',
                DeliveryAddress: {
                    AddressType: 'Delivery',
                    AddressLine1: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.DeliveryAddress?.AddressType ?? "",
                    AddressLine2: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.DeliveryAddress?.AddressLine2 ?? "",
                    City: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.DeliveryAddress?.City ?? "",
                    StateProvinceRegion: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.DeliveryAddress?.StateProvinceRegion ?? "",
                    PostZipCode: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.DeliveryAddress?.PostZipCode ?? "",
                    Country: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.DeliveryAddress?.Country ?? "",
                    Phone: "",
                    Fax: "",
                    Email: "",
                    CreatedDate: curentDateTime,
                    LastModifiedDate: curentDateTime
                },
                BillingAddress: {
                    AddressType: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.BillingAddress?.AddressType ?? "",
                    AddressLine1: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.BillingAddress?.AddressLine1 ?? "",
                    AddressLine2: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.BillingAddress?.AddressLine2 ?? "",
                    City: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.BillingAddress?.City ?? "",
                    StateProvinceRegion: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.BillingAddress?.StateProvinceRegion ?? "",
                    PostZipCode: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.BillingAddress?.PostZipCode ?? "",
                    Country: JSON.parse(sessionStorage.getItem('userCheckoutDetails'))?.BillingAddress?.Country ?? "",
                    Phone: address ? JSON.parse(localStorage.getItem('fullUserDetails')).Addresses[0].Phone : "",
                    Fax: address ? JSON.parse(localStorage.getItem('fullUserDetails')).Addresses[0].Fax : "",
                    Email: address ? JSON.parse(localStorage.getItem('fullUserDetails')).Addresses[0].Email : "",
                    CreatedDate: curentDateTime,
                    LastModifiedDate: curentDateTime
                },
            },
            ProformaInvoiceDetail: [...PIsales, ...PIoffers.filter(function (e) { return e })]
            ,
            Customer: {
                CloudCustomerID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                CompanyName: JSON.parse(localStorage.getItem('fullUserDetails')).CompanyName,
                FirstName: JSON.parse(localStorage.getItem('fullUserDetails')).FirstName,
                LastName: JSON.parse(localStorage.getItem('fullUserDetails')).LastName,
                UserName: JSON.parse(localStorage.getItem('fullUserDetails')).UserName,
                Email: JSON.parse(localStorage.getItem('fullUserDetails')).Email,
                Avatar: JSON.parse(localStorage.getItem('fullUserDetails')).Avatar,
                UserID: JSON.parse(localStorage.getItem('fullUserDetails')).UserID,
                OriginatedOrganizationID: JSON.parse(localStorage.getItem('fullUserDetails')).OriginatedOrganizationID,
                Addresses: JSON.parse(localStorage.getItem('fullUserDetails')).Addresses
            }
        }

        formSales["OrderStatus"] = 'Order Received';
        const orderoptions = {
            url: config.get('backendURL') + 'orders/add',
            method: 'POST',
            data: formSales
        };

        axios(orderoptions)
            .then(response => {
                sessionStorage.setItem('insertedId', response.data.insertedId);
            }).catch(err => {

            })


        const formlogs = {
            CloudCustomerID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
            OriginatedOrganizationID: sessionStorage.getItem('OriginatedOrganizationID'),
            CartReference: sessionStorage.getItem('ordernumber'),
            Logs: 'Order submitted',
        }

        const orderlogoptions = {
            url: config.get('backendURL') + 'orders/logs/add',
            method: 'POST',
            data: formlogs
        };

        axios(orderlogoptions)
            .then(response => {

            }).catch(err => {

            })



        const values = [];

        values.Email = contactDetails.email;
        values.ordernumber = sessionStorage.getItem('ordernumber');

        let date = new Date();
        values.ExpireDate = date.setHours(date.getHours() + 24, date.getMinutes(), 0, 0);


        axios(orderlogoptions)
            .then(wresponse => {

            }).catch(err => {

            })

        const timestamp = Math.floor(Date.now() / 1000) + 1000;

        var payload = {
            "aud": config.get('SalesjwtAud'),
            "exp": timestamp,
            "iss": config.get('SalesjwtIss')
        };

        var signOptions = {
            "algorithm": "RS256"
        };

        var privateKey = config.get('SalesprivateKey');

        var SalesAuthorizationKey = jwt.sign(payload, privateKey, signOptions);


        formSales["ProformaSales"]["PaymentToken"] = '';


        // console.log(formSales)

        fetch(config.get('API_salesregistry') + 'proformainvoice/add', {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                Authorization: `Bearer ` + SalesAuthorizationKey,
            },
            body: JSON.stringify(formSales)
        })
            .then(data => {


                formlogs["Logs"] = 'Order submitted to API';
                const orderlogoptions = {
                    url: config.get('backendURL') + 'orders/logs/add',
                    method: 'POST',
                    data: formlogs
                };

                axios(orderlogoptions)
                    .then(response => {

                    }).catch(err => {

                    })


                if (data.ok) {

                    formlogs["Logs"] = 'Order sent to API successfully';
                    const orderlogoptions = {
                        url: config.get('backendURL') + 'orders/logs/add',
                        method: 'POST',
                        data: formlogs
                    };

                    axios(orderlogoptions)
                        .then(response => {

                        }).catch(err => {

                        })

                    const updateorderoptions = {
                        url: config.get('backendURL') + 'orders/update/' + sessionStorage.getItem('insertedId'),
                        method: 'POST',
                        data: { "OrderStatus": "Order Sent to API" }
                    };

                    axios(updateorderoptions)
                        .then(response => {

                        }).catch(err => {

                        })

                    data.json().then(result => {

                        if (result.Status) {
                            const Emaildata = {
                                companyPageTitle: config.get('companyPageTitle'),
                                companyLogo: config.get('companyLogo'),
                                ordernumber: sessionStorage.getItem('ordernumber'),
                                ophours: companyDetails?.OpenningHours,
                                SenderEmail: companyDetails?.Email,
                                CustEmail: contactDetails.email,
                                phone: companyDetails?.Phone,
                                subtotal: getTotalPrice(),
                                offer: 0,
                                fullUserDetails: localStorage.getItem('fullUserDetails'),
                                deliveryMethod: sessionStorage.getItem('deliverymethod'),
                                paymentType: sessionStorage.getItem('paymentType'),
                                delivery: parseFloat(0).toFixed(2),
                                total: JSON.parse(localStorage.getItem("ECOM_SETTINGS"))[0].IsVatIncludedInSellingPrices ? parseFloat(getTotalPrice()) + parseFloat(0) : parseFloat(getTotalPrice()) + parseFloat(0) + parseFloat(0),
                                basketitem: cart,
                                address: companyDetails?.AddressLine1 + ", " + companyDetails?.AddressLine2 + ", " + companyDetails?.City + ", " + companyDetails?.StateProvinceRegion + " " + companyDetails?.PostZipCode + ", " + companyDetails?.Country,
                                email: contactDetails.email
                            }

                            const emailBody = renderEmail(OrderEmail, { lang: 'en', Emaildata });


                            async function postData() {

                                formlogs["Logs"] = 'Order Mail request sent';
                                const orderlogoptions = {
                                    url: config.get('backendURL') + 'orders/logs/add',
                                    method: 'POST',
                                    data: formlogs
                                };

                                axios(orderlogoptions)
                                    .then(response => {

                                    }).catch(err => {

                                    })

                                const ecoEmail = {
                                    "to": contactDetails.email,
                                    "bcc": config.get('companyPageTitle') + "<" + config.get('SenderEmail') + ">",
                                    "from": config.get('companyPageTitle') + "<" + config.get('SenderEmail') + ">",
                                    "subject": config.get('companyPageTitle') + " - Order Confirmation " + sessionStorage.getItem('ordernumber'),
                                    "html": emailBody
                                };
                                const response = await fetch(config.get('backendURL') + 'mail/send', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(ecoEmail)
                                })
                                return response.json();
                            }

                            postData()
                                .then(data => {
                                    const updateorderoptions = {
                                        url: config.get('backendURL') + 'orders/update/' + sessionStorage.getItem('insertedId'),
                                        method: 'POST',
                                        data: { "OrderStatus": "Order Mail Sent" }
                                    };

                                    axios(updateorderoptions)
                                        .then(response => {

                                        }).catch(err => {

                                        })
                                    console.log('Mail sent')


                                    formlogs["Logs"] = 'Order Mail sent successfully';
                                    const orderlogoptions = {
                                        url: config.get('backendURL') + 'orders/logs/add',
                                        method: 'POST',
                                        data: formlogs
                                    };

                                    axios(orderlogoptions)
                                        .then(response => {

                                        }).catch(err => {

                                        })
                                    setIsLoading(false)
                                    disptach(setCart([]))
                                    sessionStorage.removeItem('insertedId')
                                    sessionStorage.removeItem('ordernumber')
                                    sessionStorage.removeItem('deliverycost')
                                    history.push("/order-success")


                                }).catch(err => {

                                    const updateorderoptions = {
                                        url: config.get('backendURL') + 'orders/update/' + sessionStorage.getItem('insertedId'),
                                        method: 'POST',
                                        data: { "OrderStatus": "Order Mail Not Sent" }
                                    };

                                    axios(updateorderoptions)
                                        .then(response => {

                                        }).catch(err => {

                                        })
                                    setIsLoading(false)

                                    history.push("/order-failed")

                                    formlogs["Logs"] = 'Order Mail failed to send';
                                    const orderlogoptions = {
                                        url: config.get('backendURL') + 'orders/logs/add',
                                        method: 'POST',
                                        data: formlogs
                                    };

                                    axios(orderlogoptions)
                                        .then(response => {

                                        }).catch(err => {

                                        })

                                })



                        } else {
                            setIsLoading(false)
                            sessionStorage.removeItem('insertedId')
                            sessionStorage.removeItem('ordernumber')
                            history.push("/order-success")
                            formlogs["Logs"] = 'Order not sent to API due to data error: ' + result.Result;
                            const orderlogoptions = {
                                url: config.get('backendURL') + 'orders/logs/add',
                                method: 'POST',
                                data: formlogs
                            };

                            axios(orderlogoptions)
                                .then(response => {

                                }).catch(err => {

                                })
                        }
                    })
                } else {
                    setIsLoading(false)
                    const updateorderoptions = {
                        url: config.get('backendURL') + 'orders/update/' + sessionStorage.getItem('insertedId'),
                        method: 'POST',
                        data: { "OrderStatus": "Order not sent to API" }
                    };

                    axios(updateorderoptions)
                        .then(response => {

                        }).catch(err => {

                        })

                    history.push("/order-failed");
                }
            })
    }
    const sendPaymentDetailsRedirect = () => {
        const orderID = sessionStorage.getItem('ordernumber');

        const paymentDetailsRequest = {
            cloudLocationID: companyDetails?.LocationID,
            reference: `Online-${companyDetails?.LocationID}-Ecom-${orderID}`,
            siteTransactionRef: orderID,
            store: `Ecommerce_${companyDetails?.LocationID}`,
            countryCode: "GB",
            paymentDetailInput: {
                redirectResult: redirectResult

            },
            shopperReference: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),

        }
        setIsLoading(true)
        sendPaymentDetails(paymentDetailsRequest, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
            if (response) {
                if (response.resultCode && response.resultCode === "Authorised") {
                    handleCheckout()
                } else {
                    history.push(`/order-failed`)
                }
            } else {
                history.push(`/order-failed`)
            }
        })

    }
    return (
        <div className="EcommerceCheckout">
            {isLoading &&
                <div className="overlayer" ><div className="order-placing">Please wait your order in progress ...</div></div>
            }
            <div className="EcommerceCheckout-Navbar" >
                <img alt="" className="logo-container" src={companyDetails?.Logo}
                    onClick={() => {
                        history.push("/")
                    }}
                />

            </div>
            <div className="EcommerceCheckout-Container">
                <div className="EcommerceCheckout-Container-left">
                    <div className="EcommerceCheckout-container-content">
                        <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Contact"} fontSize={"24px"} />
                                {localStorage.getItem('isLogged') === 'true' ?
                                    <div className="login-text" onClick={() => {
                                        handleLogout()
                                    }}>Logout</div> :
                                    <div className="login-text" onClick={() => {
                                        history.push("/account/login")
                                    }}>Login</div>}
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="First Name"
                                    value={contactDetails.firstName}
                                    onChange={e => onContactDetailsChange(e, "firstName")}
                                    required
                                    disabled={localStorage.getItem('isLogged') === 'true'}
                                    errorMessage={errors.firstName}
                                    isError={errors.firstName}
                                />
                                <InputComponent layout="layout2"
                                    placeholder="Last Name"
                                    value={contactDetails.lastName}
                                    onChange={e => onContactDetailsChange(e, "lastName")}
                                    required
                                    disabled={localStorage.getItem('isLogged') === 'true'}
                                    errorMessage={errors.lastName}
                                    isError={errors.lastName}
                                />
                            </div>
                            <div className="input-container">
                                <InputComponent layout="layout2" placeholder="Email" value={contactDetails.email} onChange={e => onContactDetailsChange(e, "email")}
                                    required
                                    disabled={localStorage.getItem('isLogged') === 'true'}
                                    errorMessage={errors.email}
                                    isError={errors.email}
                                />
                            </div>
                            <div className="input-container">
                                <PhoneInpuComponent layout="layout2" placeholder="Phone Number" value={contactDetails.phoneNumber}
                                    onChange={e => {
                                        if (e === undefined) {
                                            setContactDetails({ ...contactDetails, ["phoneNumber"]: "" })
                                            setErrors({
                                                ...errors,
                                                ["phoneNumber"]: "",
                                            });

                                        } else {
                                            setContactDetails({ ...contactDetails, ["phoneNumber"]: e })
                                            setErrors({
                                                ...errors,
                                                ["phoneNumber"]: "",
                                            });
                                        }
                                    }
                                    }
                                    type="number"
                                    required
                                    errorMessage={errors.phoneNumber}
                                    isError={errors.phoneNumber}
                                />
                            </div>


                        </div>
                        <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Delivery"} fontSize={"24px"} />
                            </div>
                            <div className="input-container">
                                <InputComponent
                                    layout="layout2"
                                    placeholder="Address 1"
                                    value={deliveryDetails.address1}
                                    onChange={e => onDeliveryDetailsChange(e, "address1", "deliveryAddress1")}
                                    required
                                    errorMessage={errors.deliveryAddress1}
                                    isError={errors.deliveryAddress1} />
                            </div>
                            <div className="input-container">
                                <InputComponent
                                    layout="layout2"
                                    placeholder="Address 2"
                                    value={deliveryDetails.address2}
                                    onChange={e => onDeliveryDetailsChange(e, "address2", "deliveryAddress2")} />
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="City"
                                    value={deliveryDetails.city}
                                    onChange={e => onDeliveryDetailsChange(e, "city", "deliveryCity")}
                                    required
                                    errorMessage={errors.deliveryCity}
                                    isError={errors.deliveryCity} />
                                <InputComponent layout="layout2"
                                    placeholder="State"
                                    value={deliveryDetails.state}
                                    onChange={e => onDeliveryDetailsChange(e, "state", "deliveryState")}
                                    required
                                    errorMessage={errors.deliveryState}
                                    isError={errors.deliveryState}
                                />
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="Postal"
                                    value={deliveryDetails.postal}
                                    onChange={e => onDeliveryDetailsChange(e, "postal", "deliveryPostal")}
                                    required
                                    errorMessage={errors.deliveryPostal}
                                    isError={errors.deliveryPostal} />
                                <InputComponent layout="layout2"
                                    placeholder="Country"
                                    value={deliveryDetails.country}
                                    onChange={e => onDeliveryDetailsChange(e, "country")}
                                    required
                                    disabled />
                            </div>
                            <div className="input-container">
                                <Checkbox
                                    label="Same as shipping address"
                                    checked={isSame}
                                    onChange={handleCheckboxChange}
                                />
                            </div>

                        </div>
                        {!isSame && <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Billing Address"} fontSize={"24px"} />
                            </div>
                            <div className="input-container">
                                <InputComponent
                                    layout="layout2"
                                    placeholder="Address 1"
                                    value={billingDetails.address1}
                                    onChange={e => onBillingDetailsChange(e, "address1")}
                                    required
                                    errorMessage={errors.address1}
                                    isError={errors.address1} />
                            </div>
                            <div className="input-container">
                                <InputComponent
                                    layout="layout2"
                                    placeholder="Address 2"
                                    value={billingDetails.address2}
                                    onChange={e => onBillingDetailsChange(e, "address2")} />
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="City"
                                    value={billingDetails.city}
                                    onChange={e => onBillingDetailsChange(e, "city")}
                                    required
                                    errorMessage={errors.city}
                                    isError={errors.city} />
                                <InputComponent layout="layout2"
                                    placeholder="State"
                                    value={billingDetails.state}
                                    onChange={e => onBillingDetailsChange(e, "state")}
                                    required
                                    errorMessage={errors.state}
                                    isError={errors.state} />
                            </div>
                            <div className="input-grid-container">
                                <InputComponent layout="layout2"
                                    placeholder="Postal"
                                    value={billingDetails.postal}
                                    onChange={e => onBillingDetailsChange(e, "postal")}
                                    required
                                    errorMessage={errors.postal}
                                    isError={errors.postal} />
                                <InputComponent layout="layout2"
                                    placeholder="Country"
                                    value={billingDetails.country}
                                    onChange={e => onBillingDetailsChange(e, "country")}
                                    required
                                    disabled />
                            </div>

                        </div>}
                        <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Order Type"} fontSize={"24px"} />
                            </div>
                            <div className="input-container-accrodion">
                                {subOrderTypes.map((ordertype, key) => {
                                    return (
                                        <div className="accrodion-top" key={key}>
                                            <RadioButton
                                                name="order-type-options"
                                                value={ordertype.SubOrderTypeName}
                                                checked={selectedTypeValue === ordertype.SubOrderTypeName}
                                                onChange={handleTypeChange}
                                                label={ordertype.SubOrderTypeName}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="Eccomerce-form-container">
                            <div className="header-container">
                                <Header text={"Payment"} fontSize={"24px"} />
                            </div>
                            <div className="input-container-accrodion">
                                {avalaiblePaymentTypes?.map((type, key) => {
                                    return (
                                        <>

                                            <div className="accrodion-top" key={key}>
                                                <RadioButton
                                                    name="payment-options"
                                                    value={type.toUpperCase()}
                                                    checked={selectedValue === type.toUpperCase()}
                                                    onChange={handleChange}
                                                    label={type === "Cash" ? "Cash on Delivery (COD)" : "Card"}
                                                />
                                            </div>
                                            {selectedValue === "CARD" &&
                                                <EcommercePayment
                                                    ref={adyenRef}
                                                    customerDetails={
                                                        getCustomerDetails()
                                                    }
                                                    total={getCardTotalPrice()}
                                                    setIsOrderLoading={setIsLoading}
                                                    placeCartOrder={() => { handleCheckout() }}
                                                    setShowPaymentErrorModal={setShowPaymentErrorModal}
                                                    setShowPaymentError={setShowPaymentError}

                                                />
                                            }
                                        </>
                                    )
                                })}

                            </div>
                        </div>
                        <div className="Eccomerce-btn-container">
                            <Button text={"Complete Order"} width={"inherit"}
                                onClick={() => {
                                    if (validateForm() && !isLoading) {
                                        if (selectedValue === "CARD") {
                                            handlePayClick()
                                        } else {
                                            handleCheckout()

                                        }
                                    }
                                }}
                                isLoading={isLoading} />
                        </div>
                    </div>
                </div>
                <div className="EcommerceCheckout-Container-right">
                    <div className="EcommerceCheckout-container-content">
                        <div className="header-container">
                            <Header text={"Order Summary"} fontSize={"24px"} />
                        </div>
                        {cart.map((product, key) => {
                            return (
                                <CheckoutItem item={product} key={key} />
                            )
                        })}
                        <div className="EcommerceCheckout-container-total">
                            <div className="total-container">
                                <div>Subtotal</div>
                                <div>£ {getTotalPrice()}</div>
                            </div>
                            {/* <div className="total-container">
                                <div>Shipping</div>
                                <div>£ 20.00</div>
                            </div> */}
                            <div className="value-container">
                                <div>Total</div>
                                <div>£ {(parseFloat(getTotalPrice())).toFixed(2)}</div>
                            </div>

                            <div className="Eccomerce-btn-container">
                                <Button text={"Complete Order"} width={"inherit"}
                                    onClick={() => {
                                        if (validateForm() && !isLoading) {
                                            handleCheckout()
                                        }
                                    }}
                                    isLoading={isLoading} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {showPaymentErrorModal && <Modal isFailed header="Required fields are missing." subText={'Please fill in all the required payment details to continue.'} onClick={() => {
                setShowPaymentErrorModal(false)
            }} />}
            {showPaymentError && <Modal isFailed header="Something went wrong" subText={'Sorry for the inconvenience. Please check your card details or try again later.'} onClick={() => {
                setShowPaymentError(false)
            }} />}
        </div>
    )

}
export default EcommerceCheckout